import Helper from '@ember/component/helper';

import window from 'ember-window-mock';

export default class MatchMediaHelper extends Helper {
  /** @type MediaQueryList | null */
  mediaQueryList = null;
  mediaQueryString = null;

  matchesDidChange = () => this.recompute();

  // Note: the `compute` method is not a constructor and won't run when the `match-media` helper is
  // called and passed to the eg. `and` helper where the preceeding condition is falsy, such as:
  // `(and false (match-media "(min-width: 1000px)"))`. Make sure this case is handled.
  compute([mediaQueryString]) {
    if (mediaQueryString === this.mediaQueryString) {
      return this.mediaQueryList.matches;
    }

    this.mediaQueryString = mediaQueryString;

    this.mediaQueryList?.removeEventListener('change', this.matchesDidChange);

    this.mediaQueryList = window.matchMedia(this.mediaQueryString);

    if (this.mediaQueryList.addEventListener) {
      this.mediaQueryList.addEventListener('change', this.matchesDidChange);
    }

    return this.mediaQueryList.matches;
  }

  willDestroy() {
    this.mediaQueryList?.removeEventListener('change', this.matchesDidChange);
    super.willDestroy(...arguments);
  }
}
